			document.addEventListener('DOMContentLoaded', function () {
				// window.onload = function () {
				const swiper = new Swiper('.swiper01', {
					loop: true,
					speed: 1000,
					slidesPerView: 1,
					centeredSlides: false,
					autoplay: {
						delay: 2500,
						pauseOnMouseEnter: true,
						disableOnInteraction: false,
					},

					// pagination: {
					// 	el: '.swiper-pagination',
					// 	clickable: true,
					// 	dynamicBullets: false,
					// },
				});
			});
